export default "__VITE_ASSET__yZhxWlMz__"